export const SEMINARS = [
  {
    id: '01',
    title: 'Organización del Tiempo y Productividad Digital',
    category: 'Productividad',
    icon: 'Timer',
    objective: 'Organizar eficazmente el tiempo en la vida académica, haciendo uso de herramientas tecnológicas y hábitos diarios que eviten la procrastinación.',
    benefit: 'Eliminar el estrés de los deberes de última hora y administrar sus estudios con disciplina férrea.',
  },
  {
    id: '02',
    title: 'Comunicación Efectiva y Resolución de Conflictos',
    category: 'Comunicación',
    icon: 'MessageSquare',
    objective: 'Fortalecer las habilidades de comunicación efectiva y de resolución de conflictos para desarrollar la capacidad de negociar, persuadir y construir acuerdos, competencias esenciales que permiten al estudiante destacarse con confianza en los distintos contextos en los que se desenvuelve.',
    benefit: 'Comunicarse con autoridad, negociar acuerdos constructivos y presentarse con seguridad ante cualquier evaluador.',
  },
  {
    id: '03',
    title: 'Networking 5.0 y Portafolio Digital',
    category: 'Networking',
    icon: 'Network',
    objective: 'Construir habilidades de Networking 5.0 y de portafolio digital, mediante la creación de una red de contactos relevante y un portafolio personal organizado, atractivo y actualizable que visibilice sus logros académicos y proyectos.',
    benefit: 'Que el estudiante no solo tenga talento, sino pruebas tangibles e innegables de su capacidad ante las instituciones.',
  },
  {
    id: '04',
    title: 'Trabajo en Equipo y Liderazgo',
    category: 'Liderazgo',
    icon: 'Users',
    objective: 'Fortalecer la importancia del trabajo en equipo y desarrollar las habilidades para liderar, colaborar y resolver conflictos de manera constructiva.',
    benefit: 'Dejar de ser un simple seguidor para convertirse en un joven con iniciativa para tomar el control y liderar.',
  },
  {
    id: '05',
    title: 'Metodologías Ágiles para la Gestión de Proyectos: Scrum y Kanban',
    category: 'Gestión Ágil',
    icon: 'Layers',
    objective: 'Organizar, planear y gestionar proyectos académicos de forma ágil, utilizando herramientas visuales y estructuras de equipo claras (Scrum y Kanban), para evitar el desorden, cumplir tiempos de entrega y mejorar la colaboración y la productividad grupal.',
    benefit: 'Aprenderá a estructurar metas complejas y a ejecutarlas con precisión quirúrgica.',
  },
  {
    id: '06',
    title: 'IA sin Límites: Aprende a Estudiar con la Inteligencia Artificial',
    category: 'Inteligencia Artificial',
    icon: 'BrainCircuit',
    objective: 'Equipar a los estudiantes con conocimientos, habilidades y criterios éticos para usar de forma responsable, crítica y estratégica las seis inteligencias artificiales más relevantes del momento (ChatGPT, Claude, Gemini, Copilot, Perplexity y Meta AI) como aliadas de su proceso de estudio, transformando la IA en un recurso de apoyo académico, no en un sustituto de su pensamiento ni de su responsabilidad.',
    benefit: 'Multiplicar su productividad y capacidad de investigación, con una herramienta que separa a los líderes del resto.',
  },
  {
    id: '07',
    title: 'Diseño Visual con Herramientas Creativas',
    category: 'Diseño',
    icon: 'Palette',
    objective: 'Proporcionar herramientas vigentes que le permitan al estudiante potencializar sus deberes académicos y facilitar el aprendizaje.',
    benefit: 'Transmitirá sus ideas con mayor claridad, creatividad e impacto.',
  },
  {
    id: '08',
    title: 'Storytelling Digital y Personal Branding',
    category: 'Storytelling',
    icon: 'Megaphone',
    objective: 'Desarrollar habilidades de storytelling digital y construcción de marca personal para comunicar eficazmente el perfil académico y profesional.',
    benefit: 'Transmitirá sus ideas con mayor claridad, creatividad e impacto.',
  },
];

export const INCLUDES = [
  {
    title: 'Acceso completo a los 8 Seminarios',
    desc: 'Liderazgo, inteligencia emocional, trabajo en equipo, comunicación de alto impacto e inteligencia artificial.',
    img: '/images/laptop-clases.jpg',
  },
  {
    title: 'Sesiones en vivo',
    desc: 'Una sesión en vivo por semana para retroalimentación directa con sus mentores.',
    img: '/images/ipad-sesion.jpg',
  },
  {
    title: '2 Bonos especiales + Workbooks',
    desc: 'Diseño visual con herramientas creativas y storytelling con personal branding, más workbooks de trabajo.',
    img: '/images/bonos-tablet.jpg',
  },
  {
    title: 'Certificado internacional',
    desc: 'Certificado con el aval de las instituciones internacionales que respaldan el programa.',
    img: '/images/cert-tablet.jpg',
  },
];

export const ENDORSEMENTS = [
  {
    id: 'aes',
    role: 'Un programa de',
    name: 'American Elite School',
    since: '2021',
    desc: 'La escuela élite que diseña y dirige este entrenamiento intensivo de alto rendimiento para jóvenes.',
  },
  {
    id: 'fgu',
    role: 'Avalado por',
    name: 'Florida Global University',
    since: '2004',
    desc: 'Universidad estadounidense con Licencia #3180 del Departamento de Educación de Florida.',
    license: 'Licencia #3180 · Depto. de Educación de Florida',
  },
  {
    id: 'cel',
    role: 'Certificado por',
    name: 'Center of Education and Leadership',
    since: 'EE.UU.',
    desc: 'Centro internacional que certifica las competencias de educación y liderazgo adquiridas.',
  },
];

export const MARQUEE_ITEMS = [
  'Liderazgo',
  'Excelencia Académica',
  'IA sin límites',
  'Networking 5.0',
  'Storytelling Digital',
  'Scrum & Kanban',
  'Marca Personal',
  'Productividad',
];

export const ALLIANCE_MARQUEE = [
  'American Elite School',
  'Florida Global University',
  'Center of Education and Leadership',
  'Licencia #3180 · Florida, EE.UU.',
];

export const IMAGES = {
  hero: '/images/hero-campus.jpg',
  flag: '/images/flag.jpg',
  teensGroup: '/images/teens-group.jpg',
  teensTrio: '/images/teens-trio.jpg',
  teensGirls: '/images/teens-girls.jpg',
  fguCampus: '/images/fgu-campus.jpg',
  graduation: 'https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx5b3VuZyUyMHN0dWRlbnQlMjBncmFkdWF0aW9uJTIwZGlwbG9tYSUyMHRlZW4lMjBsZWFkZXJ8ZW58MHx8fHwxNzg5MTY0MDcyfDA&ixlib=rb-4.1.0&q=85&w=1600',
  collaboration: 'https://images.unsplash.com/photo-1758270705172-07b53627dfcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6NzR8MHwxfHNlYXJjaHwyfHx0ZWVuYWdlcnMlMjBzdHVkeWluZyUyMGxhcHRvcCUyMGNvbGxhYm9yYXRpb24lMjB1bml2ZXJzaXR5JTIwY2FtcHVzfGVufDB8fHx8MTc4OTE2NDA2NXww&ixlib=rb-4.1.0&q=85&w=1600',
};
